export const ANALYTICS_EVENTS = {
  APP_OPEN: 'app_open',
  SCREEN_VIEW: 'screen_view',
  ACTION: 'action',
} as const

export type AnalyticsEventName = typeof ANALYTICS_EVENTS[keyof typeof ANALYTICS_EVENTS]

export interface AnalyticsEventPayload<Screen extends string = string> {
  event: AnalyticsEventName
  session_id: string
  screen: Screen
  action?: string
  target?: Screen
}
